import cc from 'classcat';
import { dotPathNotSatisfies, isNilOrEmptyString } from 'ramda-extension';
import { parseISO } from 'date-fns/esm/fp';

import { CloudinaryImage } from '#src/components/CloudinaryImage';
import { BarChart, Clock, Requirements } from '#src/components/Icons';
import AvatarImage from '#src/components/AvatarImage';
import { formatMonthDay } from '#src/lib/formatters/temporal';
import { pluralize } from '#src/lib/formatters/strings';
import { selectCoachHost, selectCoachLabel } from '#src/lib/selectors/game';
import { gamePlayerCount } from '#src/lib/game-utils/game-stats';

import styles from './styles.module.scss';

const iconProps = {
  fill: '#ffffff',
  height: '16px',
  stroke: '#ffffff',
  width: '16px',
};

const GameItem = ({ game }) => {
  const {
    averageActivityDuration,
    difficulty,
    endDate,
    image,
    requirements,
    startDate,
    title,
  } = game;

  const playerCount = gamePlayerCount(game);

  const host = selectCoachHost(game);
  const showDuration = dotPathNotSatisfies(
    isNilOrEmptyString,
    'averageActivityDuration.value',
    game
  );

  return (
    <div className={styles.container}>
      <div className={styles.detailsGradient} />
      <div className={styles.detailsContainer}>
        {!!host && (
          <div className={styles.hostContainer}>
            <AvatarImage
              avatar={host.avatarV2}
              className={styles.avatar}
              shape="round"
              size={25}
            />
            {selectCoachLabel(host)}
          </div>
        )}
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.dates}>
          <span>
            {formatMonthDay(parseISO(startDate))} &ndash;{' '}
            {formatMonthDay(parseISO(endDate))}
          </span>{' '}
          <span>&middot;</span>{' '}
          <span>{`${playerCount} ${pluralize('player', playerCount)}`}</span>
        </div>
        <div className={styles.stats}>
          {showDuration && (
            <div className={styles.stat}>
              <Clock {...iconProps} />
              {`${averageActivityDuration.value} ${averageActivityDuration.unit}`}
            </div>
          )}
          <div className={styles.stat}>
            <BarChart {...iconProps} />
            {difficulty}
          </div>
          <div className={styles.stat}>
            <Requirements {...iconProps} />
            {requirements}
          </div>
        </div>
      </div>
      <div>
        <CloudinaryImage
          image={image}
          crop="fill"
          width={335}
          className={cc([styles.image, styles.smallImage])}
        />
        <CloudinaryImage
          image={image}
          crop="fill"
          width={674}
          className={cc([styles.image, styles.largeImage])}
        />
      </div>
    </div>
  );
};

export default GameItem;
